/*Technologies*/
import TechCard from "./TechCard";
import TechTab from "./TechTab";
import SectionHeader from "../ui/SectionHeader";
import { useState, useEffect, useRef } from "react";
import { Code2, Server, CloudCog, Database, Wrench } from "lucide-react";

function Technologies({ technologies }) {
  const [curOpen, setCurOpen] = useState("Frontend");
  const [gridVisible, setGridVisible] = useState(false);

  const gridRef = useRef(null);

  const currentTechnologies = technologies[curOpen.toLowerCase()] ?? [];

  useEffect(() => {
    const grid = gridRef.current;

    if (!grid) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        setGridVisible(true);
        observer.unobserve(entry.target);
      },
      {
        threshold: 0.2,
      },
    );

    observer.observe(grid);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="section" id="technologies">
      <SectionHeader
        eyebrow="Technology Stack"
        title="Technologies That I Use"
      />

      <div className="tech-tabs">
        <TechTab
          icon={Code2}
          label="Frontend"
          curOpen={curOpen}
          onOpen={setCurOpen}
        />

        <TechTab
          icon={Server}
          label="Backend"
          curOpen={curOpen}
          onOpen={setCurOpen}
        />

        <TechTab
          icon={CloudCog}
          label="DevOps"
          curOpen={curOpen}
          onOpen={setCurOpen}
        />

        <TechTab
          icon={Database}
          label="Databases"
          curOpen={curOpen}
          onOpen={setCurOpen}
        />

        <TechTab
          icon={Wrench}
          label="Tools"
          curOpen={curOpen}
          onOpen={setCurOpen}
        />
      </div>

      <div
        ref={gridRef}
        key={curOpen}
        className={`tech-grid ${gridVisible ? "tech-grid--animate" : ""}`}
      >
        {currentTechnologies.map((technology, index) => (
          <TechCard key={technology.name} {...technology} delay={index * 70} />
        ))}
      </div>
    </section>
  );
}

export default Technologies;
